module.exports = __webpack_public_path__ + "img/endless.d9224b6c.png";